<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19Yl9v4/tc-custom/9781480477605.jpg?1705552128881" alt="This image is the cover for the book Blue Noon, The Secret War Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blue Noon, The Secret War Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>The true story of England’s worst traitor is the backbone of this thrilling novel about love and deception behind enemy lines</b><br/> Harry Cole’s rakish charm carries him all the way from London’s East End to Hong Kong, where he chauffeurs a local colonel—when he’s not bedding the man’s wife. With the Imperial Japanese Army about to spoil the fun, Harry quits the East, settling in France just before the Nazis take over. His timing might need a little work, but he’s found the perfect cover—as the debonair Captain Mason of the British Special Operations Executive, Harry plans to stay out of the way until the war is over, and maybe make a little money in the meantime.<br/> It’s all going perfectly until a beautiful French nurse convinces Harry to stick his neck out for what is right. He finds that aiding the Resistance is just the kind of high-wire act he was born to perform, and with Odile’s support he grows bolder and more creative than ever. But the two lovers are operating in a den of deception, and risk crossing the wrong person at every turn. Sure enough, by war’s end Harry Cole is facing the one charge that even he might not be able to talk his way out of: treason.<br/><br/> Blue Noon <i>is the 2nd book in the Secret War Trilogy, which also includes </i>Early One Morning<i> and </i>Night Crossing.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Ryan
      </h2>
      
      <p class="authorDescription body article">Robert Ryan was born in Liverpool and has worked as a race car mechanic, journalist, jazz composer, university lecturer, and more. He has written many novels, including&#160;<i>Early One Morning</i>, a <i>Sunday Times</i> (UK) bestseller. He lives in North London with his wife, three children, a dog, and a deaf cat.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54a527b0